export default "__VITE_ASSET__2jDuUp0J__"